import {PollListDetails} from '~/features/Polls/PollList';

export const PollListScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PollListDetails />
    </div>
  );
};
